module.exports = __webpack_public_path__ + "media/images/flags/ao-71fa415ce733ac3c01e2a894faaa7a0d.svg";